<!-- <div *ngIf="userConsent=='no'" class=""> -->
<div class="consent_popup" *ngIf="userConsent=='no'">
  <div class="consent_popup_content">
    <!-- <h3>Guide to starting Email notification service</h3> -->
    <h3>{{noticeHeading}}</h3>
    <p style="white-space: pre-line;" [innerHTML]="noticeContent"></p>
    
    <div class="consent_footer">
      <label><input type="checkbox" #acceptTerms> {{"HaveRead" | translate}}</label>
      <button class="btn btn-primary btn-sm" (click)="giveConsent(acceptTerms.checked)">OK</button>
      <!-- <button class="btn btn-warning btn-sm" id="consent_close" (click)="cancelConsent()">Cancel</button> -->
    </div>
  </div>

</div>
 <!-- class="consent_close" -->

<!---------------------- Email Setting Update pop up ----------------------> 
<div class="email-accept" *ngIf="emailSuccess">
  <div class="email-accept_content" *ngIf="lang === 'jp'">
    <h3>メールアドレスの認証成功</h3>
    <p>新しいメールアドレスが登録されました。</p>
    <div class="consent_footer">
      <button class="btn btn-primary" (click)="close()">OK</button>
    </div>
  </div>
  <div class="email-accept_content" *ngIf="lang === 'en'">
    <h3>Email Address Verification Successful</h3>
    <p>A new email address has been registered.</p>
    <div class="consent_footer">
      <button class="btn btn-primary" (click)="close()">OK</button>
    </div>
  </div>

</div>
<!--------------------------------------END Pop up ------------------------->

<!--  ############### Top Select Month Start ################# -->
<div class="select_month_section">
  <div class="row">
    <div class="col-sm-5 select_month">
      <h2><label for="select_year_month">{{"SELECTMONTH" | translate}}</label> </h2>
      <div class="select_month_row">
        <select
          class="form-select"
          aria-label="Month selection"
          [(ngModel)]="selectedMonth"
          (change)="fncCng($event)">
            <option *ngFor="let date of monthDropdown" [value]="date.dayDate">
              {{(lang == 'en') ? date.eNdate: date.jPdate}}
            </option>
        </select>
      </div>
      <div class="multi_ts_notice" *ngIf="allAssociatesData && allAssociatesData.length > 1">
        <span class="multi_ts_pc" *ngIf="lang === 'jp'">当月は複数のタイムシートがあります：</span>
        <span class="multi_ts_pc" *ngIf="lang !== 'jp'">There are multiple timesheets for the current month:</span>
        <span class="multi_ts_mobile" *ngIf="lang === 'jp'">複数TSあり：</span>
        <span class="multi_ts_mobile" *ngIf="lang !== 'jp'">TS Selection:</span>
        <a *ngFor="let assoc of allAssociatesData; let i = index"
           (click)="selectAssociate(i)"
           [class.active]="i === selectedAssociateIndex"
           style="cursor: pointer; text-decoration: none;">{{i + 1}}</a>
      </div>
    </div>
  </div>
</div>
<!--  ############### Top Select Month End ################# -->
<!--  ############### Middle Containt Area Start ################# -->
<div class="container_wrapper" *ngIf="!noAvailableMonthData">
  <!--  ############### Row 1 Start ################# -->
  <div class="dashboard_blocks_wrapper" *ngFor="let item of associatesData">
    <!--  ############### Block 1 Loop Start ################# -->
    <div class="dashboard_blocks">
      <div class="dashboard_blocks_header sections">
        <h4 class="section_block">{{"SECTION" | translate}} - </h4><span class="section_value">{{item.section}}</span>        
      </div>
      <!--  ############### Block Content Start ################# -->
      <div class="dashboard_blocks_content">
        <h3 class="mobilenv">{{"TWH" | translate}}</h3>
        <div class="total_works">
          <div class="tw_times">
            <section>
              <img src="assets/regular_icon.svg" alt="Regular Icon">
              <div class="tw_section_text">
                <h5>{{"REGULAR" | translate}}</h5>
                <h4>{{item.regular}}</h4>
              </div>
            </section>
            <section>
              <img src="assets/over_time_icon.svg" alt="Overtime Icon">
              <div class="tw_section_text">
                <h5>{{"OVERTIME" | translate}}</h5>
                <h4>{{item.overtime}}</h4>
              </div>
            </section>
            <section>
              <img src="assets/regular_icon.svg" alt="Midnight In">
              <div class="tw_section_text">
                <h5>{{"MIDNIGHT_IN" | translate}}</h5>
                <h4>{{item.midnightInside}}</h4>
              </div>
            </section>
            <section>
              <img src="assets/regular_icon.svg" alt="Midnight Out">
              <div class="tw_section_text">
                <h5>{{"MIDNIGHT_OUT" | translate}}</h5>
                <h4>{{item.midnightOutside}}</h4>
              </div>
            </section>
          </div>
          <section class="tw_total_section">
            <img src="assets/total_icon.svg" alt="Total Icon">
            <div class="tw_section_text">
              <h5>{{"TOTAL" | translate}}</h5>
              <h4>{{item.total}}</h4>
            </div>
          </section>
        </div>
      </div>
      <!--  ############### Block Content End ################# -->

    </div>
    <!--  ############### Block 1 Loop End ################# -->
    <!--  ############### Block 2 Loop Start ################# -->
    <div class="dashboard_blocks">
      <div class="dashboard_blocks_header">
        <h4>{{"CONTRACTTERM" | translate}} - </h4>
        <span class="section_value">{{item.contractTerm}}</span>
        <a [routerLink]="['/timesheet', item.timesheetID]">{{'EnterTimesheet' | translate}}</a>
      </div>
      <!--  ############### Block Content Start ################# -->
      <div class="dashboard_blocks_content">
        <h3 class="mobilenv">{{"STATUS" | translate}}</h3>
        <div class="status_chart">
          <div class="status_legend">
            <div class="legend_item">
              <span class="legend_left">
                <span class="legend_dot" style="background:#CCCC00"></span>
                <span class="legend_label">{{ 'LONGSTATUS.NOTSUBMIT' | translate }}</span>
              </span>
              <span class="legend_value">{{ item.notSubmit }}</span>
            </div>
            <div class="legend_item">
              <span class="legend_left">
                <span class="legend_dot" style="background:rgba(112,191,92,1)"></span>
                <span class="legend_label">{{ 'LONGSTATUS.SUBMIT' | translate }}</span>
              </span>
              <span class="legend_value">{{ item.submit }}</span>
            </div>
            <div class="legend_item">
              <span class="legend_left">
                <span class="legend_dot" style="background:rgba(228,65,95,1)"></span>
                <span class="legend_label">{{ 'REJECT' | translate }}</span>
              </span>
              <span class="legend_value">{{ item.reject }}</span>
            </div>
            <div class="legend_item">
              <span class="legend_left">
                <span class="legend_dot" style="background:rgba(56,147,205,1)"></span>
                <span class="legend_label">{{ 'APPROVE' | translate }}</span>
              </span>
              <span class="legend_value">{{ item.approve }}</span>
            </div>
          </div>
          <div class="status_pie_wrap">
            <canvas baseChart
              [type]="paiChartType"
              [data]="item.pieChartCombined"
              [options]="pieChartOptions">
            </canvas>
          </div>
        </div>
      </div>
      <!--  ############### Block Content End ################# -->

    </div>
    <!--  ############### Block 2 Loop End ################# -->
    <!--  ############### Block 3 Loop Start ################# -->
    <div class="dashboard_blocks">
      <div class="dashboard_blocks_header sections">
        <h4 class="section_block">{{"dashboard.TimesheetSummary" | translate}} - </h4>
        <span *ngIf="lang === 'jp'" class="section_value">{{disYear}}年{{"DDMONTH."+monthFormat | translate}}</span>
        <span *ngIf="lang === 'en'" class="section_value">{{"DDMONTH."+monthFormat | translate}} {{disYear}}</span>
      </div>
      <!--  ############### Block Content Start ################# -->
      <div class="dashboard_blocks_content">
        <div class="summary_chart">
          <section>
            <canvas baseChart
            [type]="barChartType"
            [data]="item.barChartData"
            [options]="barChartOptions">
          </canvas>
          </section>
        </div>
      </div>
      <!--  ############### Block Content End ################# -->

    </div>
    <!--  ############### Block 3 Loop End ################# -->
  </div>

  

  <!--  ############### Row 1 End ################# -->

</div>
<div class="select_month_section alert alert-warning" *ngIf="noAvailableMonthData">  
    {{"NO_MONTH_SELECTED" | translate}}
</div>

<!-- 2026/07/20 一時的に追加 -->
<!-- <div class="email-notice-box timesheet-temp-notice">
  <div class="email-notice-box__text">
    <strong class="timesheet-temp-notice__title">※タイムシートのご確認をお願いいたします。</strong>
    <p>
      7月分のタイムシートについて、7/20(月・祝)の勤怠レコードに通常の勤務時間が初期設定されていました。
      まだご報告いただいていない勤怠についてはデータをクリアさせていただきました。<br />
      既にご報告いただいているレコードについてはそのままとなっておりますので、
      <span class="red">7/20 分のご報告が正しいかどうかをご確認くださいますようお願いいたします。</span>
    </p>
  </div>
</div> -->

<!-- Password Expiry Notice -->
<div class="email-notice-box" *ngIf="passwordExpiryDate || userEmail">
  <div class="email-notice-box__text">
    <p>{{'STAFF_EMAIL_NOTICE_LINE1' | translate}}</p>
    <p>{{'STAFF_EMAIL_NOTICE_LINE2' | translate}}</p>
  </div>
  <p class="email-notice-box__info" *ngIf="userEmail || passwordExpiryDate">
    <strong *ngIf="userEmail">{{'EMAIL_NOTICE_CURRENT' | translate}}　{{ userEmail }}</strong>
    <strong *ngIf="passwordExpiryDate" class="email-notice-box__info-sep">{{'PASSWORD_LIMIT' | translate}}　{{ passwordExpiryDate }}</strong>
  </p>
  <p class="email-notice-box__text email-notice-box__footer">{{'STAFF_EMAIL_NOTICE_LINE3' | translate}}</p>
</div><!--  ############### Middle Containt Area End ################# -->
